//  @flow
import React, { memo } from 'react';
//  $Ignore
import { NavLink } from 'react-router-dom';
import Tag from '../Tag';

import './style.css';

type CustomLinkProps = {
  icon?: string,
  text: string,
  to: string,
  tag?: string,
  className?: string,
  activeStyle?: string
};

const CustomLink = memo((props: CustomLinkProps) => {
  const {
    icon,
    text,
    to,
    className = '',
    activeStyle = '',
    tag = '',
    isExternalLink = false
  } = props;
  return (
    <div className={`custom-link ${className}`}>
      {Boolean(icon) && <i className={icon} />}
      {isExternalLink ? (
        <a target="_blank" className="nav-link" href={to}>
          <span className="nav-span">
            {text}
            {tag && <Tag style={{ top: '-15px' }} text={tag} color="red" />}
          </span>
        </a>
      ) : (
        <NavLink
          className="nav-link"
          exact
          to={to}
          activeClassName={`custom-link-active ${activeStyle}`}>
          <span className="nav-span">
            {text}
            {tag && <Tag style={{ top: '-15px' }} text={tag} color="red" />}
          </span>
        </NavLink>
      )}
    </div>
  );
});

export default CustomLink;



// WEBPACK FOOTER //
// ./src/Components/CustomLinks/index.js